import { SAVE_RESPONSE, SET_STATE } from '../actions/response/type';

const feedbackResponseReducer = (state, { type, payload }) => {
  const currentFeedbackState = state;
  switch (type) {
    case SET_STATE:
      return payload;

    case SAVE_RESPONSE:
      return {
        ...currentFeedbackState,
        answers: currentFeedbackState.answers.map((response) => {
          if (response.id === payload.id) {
            return {
              ...response,
              answer: payload.answer,
            };
          }
          return response;
        }),
      };

    default:
      return currentFeedbackState;
  }
};

export default feedbackResponseReducer;
